import React, { useState } from 'react';
import { Modal } from '../../components/ui';
import { useFetch } from '../../hooks/useFetch';
import { errMsg, fmt } from '../../utils/format';
import api from '../../utils/api';

export default function VendorDiscountsModal({ vendor, onClose }) {
  const { data, refetch } = useFetch(`/api/vendor-discounts?vendorId=${vendor.id}`);
  const [form, setForm] = useState({ minQuantity:'', discountPct:'' });
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [saving, setSaving] = useState(false);

  const tiers = (data || []).sort((a,b) => a.min_quantity - b.min_quantity);

  const add = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      await api.post('/api/vendor-discounts', {
        vendorId: vendor.id,
        minQuantity: parseFloat(form.minQuantity),
        discountPct: parseFloat(form.discountPct),
      });
      setForm({ minQuantity:'', discountPct:'' });
      refetch();
    } catch(err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  const saveEdit = async (id) => {
    try {
      await api.patch(`/api/vendor-discounts/${id}`, {
        minQuantity: parseFloat(editForm.minQuantity),
        discountPct: parseFloat(editForm.discountPct),
      });
      setEditId(null);
      refetch();
    } catch(err) { alert(errMsg(err)); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this discount tier?')) return;
    try { await api.delete(`/api/vendor-discounts/${id}`); refetch(); }
    catch(err) { alert(errMsg(err)); }
  };

  return (
    <Modal title={`Quantity Discounts — ${vendor.name}`} onClose={onClose}
      footer={<button className="btn" onClick={onClose}>Close</button>}>

      {/* Existing tiers */}
      {tiers.length > 0 && (
        <table style={{ width:'100%', marginBottom:16, fontSize:13 }}>
          <thead>
            <tr style={{ borderBottom:'1px solid var(--border)' }}>
              <th style={{ textAlign:'left', padding:'4px 8px' }}>Min quantity</th>
              <th style={{ textAlign:'left', padding:'4px 8px' }}>Discount</th>
              <th style={{ width:80 }}></th>
            </tr>
          </thead>
          <tbody>
            {tiers.map(t => (
              <tr key={t.id} style={{ borderBottom:'1px solid var(--border)' }}>
                {editId === t.id ? (
                  <>
                    <td style={{ padding:'4px 8px' }}>
                      <input type="number" min="0" step="1" value={editForm.minQuantity}
                        onChange={e=>setEditForm(f=>({...f,minQuantity:e.target.value}))}
                        style={{ width:100 }} />
                    </td>
                    <td style={{ padding:'4px 8px' }}>
                      <input type="number" min="0" max="100" step="0.01" value={editForm.discountPct}
                        onChange={e=>setEditForm(f=>({...f,discountPct:e.target.value}))}
                        style={{ width:80 }} />
                      <span style={{ marginLeft:4 }}>%</span>
                    </td>
                    <td style={{ padding:'4px 8px', display:'flex', gap:4 }}>
                      <button className="btn btn-sm btn-primary" onClick={() => saveEdit(t.id)}>Save</button>
                      <button className="btn btn-sm" onClick={() => setEditId(null)}>Cancel</button>
                    </td>
                  </>
                ) : (
                  <>
                    <td style={{ padding:'6px 8px' }}>≥ {parseFloat(t.min_quantity).toLocaleString()}</td>
                    <td style={{ padding:'6px 8px', color:'var(--color-success)', fontWeight:500 }}>{t.discount_pct}%</td>
                    <td style={{ padding:'4px 8px', display:'flex', gap:4 }}>
                      <button className="btn btn-sm" onClick={() => { setEditId(t.id); setEditForm({ minQuantity: t.min_quantity, discountPct: t.discount_pct }); }} title="Edit">
                        <i className="ti ti-pencil" />
                      </button>
                      <button className="btn btn-sm btn-danger" onClick={() => del(t.id)} title="Delete">
                        <i className="ti ti-trash" />
                      </button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {!tiers.length && (
        <div style={{ color:'var(--text-tertiary)', fontSize:13, marginBottom:16 }}>
          No discount tiers set up yet. Add one below.
        </div>
      )}

      {/* Add new tier */}
      <div style={{ borderTop:'1px solid var(--border)', paddingTop:16 }}>
        <div style={{ fontWeight:600, fontSize:13, marginBottom:10 }}>Add discount tier</div>
        <form onSubmit={add} style={{ display:'grid', gridTemplateColumns:'1fr 1fr auto', gap:8, alignItems:'end' }}>
          <div className="form-group" style={{ margin:0 }}>
            <label style={{ fontSize:11 }}>Min quantity</label>
            <input type="number" min="1" step="1" placeholder="e.g. 1000" required
              value={form.minQuantity} onChange={e=>setForm(f=>({...f,minQuantity:e.target.value}))} />
          </div>
          <div className="form-group" style={{ margin:0 }}>
            <label style={{ fontSize:11 }}>Discount (%)</label>
            <input type="number" min="0.01" max="100" step="0.01" placeholder="e.g. 10" required
              value={form.discountPct} onChange={e=>setForm(f=>({...f,discountPct:e.target.value}))} />
          </div>
          <button className="btn btn-primary btn-sm" type="submit" disabled={saving}>
            {saving ? 'Adding…' : 'Add tier'}
          </button>
        </form>
        <div style={{ fontSize:11, color:'var(--text-tertiary)', marginTop:6 }}>
          When a PO line item quantity meets or exceeds the minimum, the discount is automatically applied.
        </div>
      </div>
    </Modal>
  );
}
